import React from "react"
import "./preView.css"

export class explore extends React.Component {
	constructor (args) {
		super(args)
		this.state = {}
	}
	render () {
		return (
			<div className="section__content">
				<div className="prelodSection__wrapper">
					<div className="prelodSection_content">
						<div id="preloader">
							<div id="loader"></div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default explore



// WEBPACK FOOTER //
// ./src/components/preloaderSection/index.js